import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import CabinsFullWidth from "../components/cabinsFullWidth"
import RatesTables from "../components/Rates"

const Rates = () => {
  return (
    <Layout>
      <SEO
        title="Rates"
        description="Seasonal nightly rates for Gold Coast Retreat's Tofino cabin rentals at Chesterman Beach, based on double occupancy."
      />
      <CabinsFullWidth />
      <RatesTables />
    </Layout>
  )
}

export default Rates
